import * as request from '@/utils/request'

export default {
  /**
   * @description 同步关联：把已签约的红人信息同步到星广汇
   * @param {*} data { artist_id }
   * @returns
   */
  syncSignInfoToAd(data) {
    return request.post('/sign_info/sync_to_ad', data)
  },
  /**
   * @description 获取列表
   * @param {*} data
   * @returns
   */
  getSignInfoList(data) {
    return request.post('/sign_info/list', data)
  },

  /**
   * @description 获取签约红人真实信息列表
   * @param {*} data
   * @returns
   */
  getSignPrivacyList (data) {
    return request.get('/sign_info/sign_privacy_list', data)
  },

  /**
   * @description 获取签页人列表
   * @param {*} data
   * @returns
   */
  getSignInfoSignatoryList(data) {
    return request.post('/sign_info/get_signatory_list', data)
  },
  /**
   * 导入
   * @param data
   * @return {*}
   */
  importSignInfo(data) {
    return request.post('/sign_info/import', data)
  },
  /**
   * @description 保存
   * @param {*} data
   * @returns
   */
  saveSignInfo(data) {
    return request.post('/sign_info/store', data)
  },
  /**
   * 修改红人解约时间
   * @param data
   * @returns {Promise}
   */
  editSignFiredTime(data) {
    return request.post('/sign_info/change_fired_time', data)
  },
  /**
   * @description 获取详情
   *
   * @param {*} id
   * @returns
   */
  getSignInfo(id) {
    const data = { id: id }
    return request.post('/sign_info/get_info', data)
  },

  getKolSignInfo(artist_id) {
    const data = { artist_id: artist_id }
    return request.post('/sign_info/get_kol_info', data)
  },
  /**
   * @description 删除签约信息
   *
   * @param {*} id
   * @returns
   */
  deleteSignInfo(id) {
    const data = { id: id }
    return request.post('/sign_info/delete', data)
  },
  /**
   * 红人转组
   * @param artist_id 红人ID
   * @param toGroupId 新组ID（可以是部门）
   * @returns {Promise}
   */
  signInfoGroupTransfer(artist_id, toGroupId) {

    return request.post('/sign_info/group_transfer', { 'artist_id': artist_id, group_id: toGroupId })
  },
  /**
   * @description 转组记录
   * @param {*} data
   * @returns
   */
  signArtistGroupList(data) {
    return request.post('/sign_info/artist_groups_list', data)
  },
  /**
   * @description 保存
   * @param {*} data
   * @returns
   */
  signInfoFired(data) {
    return request.post('/sign_info/fired_sign', data)
  },
  /**
   * @description 搜索：签约人
   * @param qs
   * @returns
   */
  searchSignInfo(qs) {
    const data = { search: qs }
    return request.post('/sign_info/search', data)
  },
  /**
   * @description 导出
   * @param {*} data
   * @returns
   */
  exportSignInfoList(data) {
    return request.postBlob('/sign_info/export', data)
  },
  /**
   * @description 签约管理顶部统计
   * @param {*} data
   * @returns
   */
  getSignOverview(data) {
    return request.post('/sign_info/get_sign_overview', data)
  },
  /**
   * @description 页面使用量埋点
   * @param {*} data
   * @returns
   */
  saveAiChatRequestLog(data) {
    return request.post('/ai_chat_request_log/save', data)
  },
  /**
   * @description 签约情况一览
   * @param qs
   * @returns
   */
  signInfoOverview(data) {

    return request.post('/sign_info/summary', data)
  },
  /**
   * 签约情况一览：明细
   * @param data
   * @returns {Promise}
   */
  getSignSummaryDetail(data) {
    return request.post('/sign_info/summary_detail', data)
  },

  /**
   * 签约部门读取
   * @param data
   * @returns {Promise}
   */
  getSignatorySetting(data) {
    return request.post('/sign_info/signatory_setting', data)
  },
  //
  // /**
  //  * 续签
  //  */
  // renewalSignInfo(data) {
  //   return request.post('/sign_info/renewal', data)
  // },

  /**
   * 添加红人信息
   * @param data
   * @returns {Promise}
   */
  addSignInfo(data) {
    return request.post('/sign_info/add', data)
  },
  /**
   * 修改红人信息
   * @param data
   * @returns {Promise}
   */
  editSignInfo(data) {
    return request.post('/sign_info/edit', data)
  },
  /**
   *
   * @param data
   * @returns {Promise}
   */
  getKolSignList(data) {
    return request.post('/sign_info/kol_sign_list', data)
  },
  /**
   * 新增或修改签约记录
   * @param data
   * @returns {Promise}
   */
  saveKolSignRecord(data) {
    const url = data.id ? '/sign_info/edit_record' : '/sign_info/add_record'
    return request.post(url, data)
  },
  /**
   * 查询红人结算信息
   */
  getArtistPayments(data) {
    return request.get('/sign_info/payments', data)
  },
  /**
   * 新增、修改红人结算信息
   * @param data
   * @param artist
   * @returns {Promise}
   */
  saveArtistPaymentRecord(data, artist = { artist_id: '', nickname: '' }) {
    const formData = {
      platform: data.platform,
      user_id: artist.artist_id,
      nickname: artist.nickname,
      name: data.payment_target || '',
      open_bank: data.bank_name || '',
      account: data.payment_account || '',
      settle_method: data.settle_method || '',
      invoice_type: data.invoice_type || '',
      tax_point: data.tax_point || '',
      template_type: 1
    }
    if (data.id) {
      formData.id = data.id
    }
    // console.log('f', formData)
    return request.post('/artist_payment/store', formData)
  },
  /**
   * 删除红人结算信息
   * @param ids
   * @returns {Promise}
   */
  deleteArtistPaymentRecord(ids) {
    return request.post('/artist_payment/delete', { ids })
  },

  /**
   * 获取标签列表
   *
   * @returns {Promise}
   */
  getTagOptions() {
    return request.post('/sign_info/getTags', {})
  },
  /**
   *
   * 给红人打标签
   * @param artist_id
   * @param tag_id
   * @returns {Promise}
   */
  saveArtistTag(artist_id, tag_id) {
    return request.post('/sign_info/saveTag', { 'artist_id': artist_id, 'tag_id': tag_id })
  },

  /**
   * 取消标签
   * @param artist_id
   * @param tag_id
   * @returns {Promise}
   */
  delArtistTag(artist_id, tag_id) {
    return request.post('/sign_info/deleteTag', { 'artist_id': artist_id, 'tag_id': tag_id })
  }
}
